import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserService from "rc-app/services/UserService";
import { getAgencyById, getAgencyLogo } from "rc-app/api/agencyActionsApi";
import { getCustomerList } from "rc-app/api/customerActionsApi";

const HomeRedirect: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (UserService.hasRole("customer")) {
      const resolveCustomerAgencies = async () => {
        try {
          let agencies: any[] = [];
          sessionStorage.removeItem("customerAgencies");
          sessionStorage.removeItem("customerAgencySelected");

          const listRes = await getCustomerList(0, 100, "", "", "", UserService.getUseremail());
          const records: any[] = listRes?.re_customer_list || [];
          const agencyMap = new Map<string, any>();
          for (const record of records) {
            const aId = record?.agency_id;
            if (aId && !agencyMap.has(aId)) {
              const agencyData = await getAgencyById(aId);
              if (agencyData?.slug) {
                agencyMap.set(aId, {
                  id: aId,
                  slug: agencyData.slug,
                  name: agencyData.name || "",
                  logo: agencyData.logo || "",
                });
              }
            }
          }
          agencies = Array.from(agencyMap.values());
          sessionStorage.setItem("customerAgencies", JSON.stringify(agencies));

          if (cancelled) return;

          if (agencies.length === 0) {
            setError("No agency found for your account.");
            return;
          }

          if (agencies.length === 1) {
            localStorage.setItem("agencySlug", agencies[0].slug);
            navigate(`/c/${agencies[0].slug}`, { replace: true });
            return;
          }

          // Multiple agencies — always show selection screen on login
          navigate("/agency-select", { replace: true });
        } catch (e: any) {
          if (cancelled) return;
          setError(e?.message ?? "Could not resolve agency.");
        }
      };
      resolveCustomerAgencies();
    } else {
      const cached = localStorage.getItem("agencySlug");
      if (cached) {
        navigate(`/c/${cached}`, { replace: true });
      } else {
        getAgencyLogo(UserService.getUseremail())
          .then((res: any) => {
            if (cancelled) return;
            const slug = res?.slug;
            if (slug) {
              localStorage.setItem("agencySlug", slug);
              navigate(`/c/${slug}`, { replace: true });
            } else {
              setError("Your agency has no slug configured.");
            }
          })
          .catch((e: any) => {
            if (cancelled) return;
            setError(e?.message ?? "Could not resolve agency.");
          });
      }
    }

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="h-full flex items-center justify-center bg-gradient-to-b from-[#1C2C3A] to-[#1E4F52] text-white">
      {error ? (
        <div className="text-sm text-red-300 bg-red-900/30 px-4 py-3 rounded">
          {error}
        </div>
      ) : (
        <span className="inline-block w-6 h-6 rounded-full border-2 border-white/30 border-t-white animate-spin" />
      )}
    </div>
  );
};

export default HomeRedirect;
